import React from 'react';
import {
  getBranchRoles,
  isAuthenticated
} from '../../../../utils/session-util';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { SIGN_IN_URL } from '../../../../route-names';
import PropTypes from 'prop-types';
import { getHomeUrlForUser } from '../../../../utils/utils';
import * as UserType from '../../../../constants/UserType';

// Check if user is authenticated, not restricted, and has at least access to one branch
// with the correct role
const hasAccessToRoute = (props) =>
  isAuthenticated() &&
  (props.unrestricted ||
    props.permittedUserTypes.some((pt) =>
      Object.values(getBranchRoles()).some((role) => pt === UserType[role])
    ));

const getRedirectUrl = () =>
  isAuthenticated() ? getHomeUrlForUser() : SIGN_IN_URL;

const AuthedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      hasAccessToRoute(rest) ? (
        <Component {...props} />
      ) : (
        <Redirect to={getRedirectUrl()} />
      )
    }
  />
);

AuthedRoute.propTypes = {
  unrestricted: PropTypes.bool,
  permittedUserTypes: PropTypes.arrayOf(PropTypes.object)
};

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

export default connect(mapStateToProps)(AuthedRoute);
